import config from '../config'
import { requests } from '.'

export const CompanyService = {
  getById: (id: string) => requests(config.companyUrl).get(`/${id}`),
  updateById: (id: string, body: any) =>
    requests(config.companyUrl).put(`/${id}`, body),
  getBusinessNiche: (category: string) =>
    requests(config.companyUrl).get(`/business-niche/${category}`)
}
